import ResetPasswordScreen from './ResetPasswordScreen';
export default ResetPasswordScreen;
